<template>
  <div class="result w-full">
    <div class="w-full text-center">
      <h1 class="my-6 text-xl md:text-2xl lg:text-3xl font-bold leading-tight text-gray-100">Your result has been calculated:</h1>
      <checkmarkSVG class="mx-auto w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 fill-current text-gray-100" viewBox="0 0 512 512"/>
      <p class="my-6 text-base md:text-lg lg:text-xl font-medium leading-tight text-gray-100">The algorithm has found your <span class='text-highlight font-bold'>perfect</span> online business. With this business you can easily earn up to <span class='text-highlight font-bold lowercase'>{{ suggestions[3] }}</span> as a <span class='lowercase'>{{ suggestions[2] }}</span>. <span class='font-bold'>Click right now on the yellow button below:</span></p>
    </div>
    <div>
    </div>
    <button class="w-full animate-bounce bg-highlight active:opacity-50 text-dark text-lg md:text-xl lg:text-2xl font-bold py-4 px-4 mt-6 rounded uppercase shadow-white" ontouchstart="" @click="linkButtonAction">
      <div class="inline-flex">
        <arrowSVG class="w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 mr-2 fill-current" viewBox="0 0 512 512"/>
        <span>Get the result now</span>
      </div>
    </button>
  </div>
</template>

<script>
import arrowSVG from "@/assets/icons/arrow-redo.svg?inline";
import checkmarkSVG from "@/assets/icons/checkmark-circle.svg?inline";

export default {
  name: 'Result',
  props: {
    suggestions: Array,
  },
  components: {
    arrowSVG,
    checkmarkSVG
  },
  methods: {
    linkButtonAction: function() {
      var win = window.open("http://bit.ly/YOUR-PERFECT-BUSINESS", '_blank');
      win.focus();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
